import React from 'react';
import useStyles from '@front10/helpers/dist/UseStyles';
import Col from '../../../elements/Col';
import Row from '../../../elements/Row';
import Box from '../../../elements/Box';

const styles = {
  header: {
    height: '25px',
    marginBottom: '0.5rem',
  },
  selectorControls: {
    height: '40px',
    marginBottom: '0.25rem',
  },
  selectorControlLast: {
    height: '40px',
    marginBottom: '0.5rem',
  },
  disclaimer: {
    height: '20px',
    marginTop: '0.25rem',
  },
  fareItem: {
    height: '100px',
    marginBottom: '0.25rem',
  },
};

const SkeletonFeaturedDestinationsMobile = (props) => {
  const [className, style] = useStyles(props);
  const { header, selectorControls, fareItem, selectorControlLast, disclaimer } = styles;
  return (
    <Box
      className={`${className} fr-skeleton`}
      style={style}
      dataTestId="skeletonFeaturedDestinationsMobile"
    >
      <Row gutters>
        <Col>
          <Box className="fr-skeleton-element" style={header} />
        </Col>
      </Row>
      <Row gutters>
        <Col>
          <Box className="fr-skeleton-element" style={selectorControls} />
        </Col>
      </Row>
      <Row gutters>
        <Col>
          <Box className="fr-skeleton-element" style={selectorControls} />
        </Col>
      </Row>
      <Row gutters>
        <Col>
          <Box className="fr-skeleton-element" style={selectorControlLast} />
        </Col>
      </Row>
      <Row gutters>
        <Col>
          <Box className="fr-skeleton-element" style={fareItem} />
        </Col>
      </Row>
      <Row gutters>
        <Col>
          <Box className="fr-skeleton-element" style={fareItem} />
        </Col>
      </Row>
      <Row gutters>
        <Col>
          <Box className="fr-skeleton-element" style={fareItem} />
        </Col>
      </Row>
      <Row gutters>
        <Col>
          <Box className="fr-skeleton-element" style={fareItem} />
        </Col>
      </Row>
      <Row gutters>
        <Col xs="8">
          <Box className="fr-skeleton-element" style={disclaimer} />
        </Col>
      </Row>
    </Box>
  );
};

SkeletonFeaturedDestinationsMobile.componentName = 'SkeletonFeaturedDestinationsMobile';

export default SkeletonFeaturedDestinationsMobile;
